// import { setHomeSpecialCars } from 'shared/actions/homeSpecialCars';
import queryString from 'query-string';
import shuffle from 'lodash/shuffle';
import React from 'react';
import API from 'shared/constants/api';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import TITLE from 'shared/constants/seoTitles';
import Layout from '../../components/Layout';
import NotFound from './NotFound';

const CURRENT_TRANSPORT_ID = 1;

async function action({ fetch, translate, store }) {
  const title = TITLE.NOT_FOUND(translate);
  const description = DESCRIPTION.NOT_FOUND(translate);

  const promisesToAwait = [];

  let specialCars;
  const PRICE_FROM = 1000000;
  const CARS_IN_LIST = 20;
  const LITVA_ID = 4482;

  const vipParam = { is_vip: CURRENT_TRANSPORT_ID };
  const priceParam = { price_from: PRICE_FROM };

  promisesToAwait.push(
    Promise.all([
      fetch(
        API.ADVERT.ALL(
          `?${queryString.stringify({ ...vipParam, transport: CURRENT_TRANSPORT_ID })}`,
        ),
      ).then(r => r && r.json && r.json()),
      fetch(
        API.ADVERT.ALL(
          `?${queryString.stringify({ ...priceParam, transport: CURRENT_TRANSPORT_ID })}`,
        ),
      )
        .then(r => r && r.json && r.json())
        .then(r => r.results),
      //
      [],
      // fetch(
      //   API.ADVERT.ALL(
      //     `?${queryString.stringify({ location: LITVA_ID, transport: CURRENT_TRANSPORT_ID })}`,
      //   ),
      // )
      //   .then(r => r && r.json && r.json())
      //   .then(r => r.results),
    ]).then(([vipCars, lowPriceCars, litvaCars]) => {
      specialCars = {
        vipCars,
        lowPriceCars,
        europeCars: shuffle(litvaCars || []).slice(0, CARS_IN_LIST),
      };
      // store.dispatch(setHomeSpecialCars(specialCars));
    }),
  );

  await Promise.all(promisesToAwait);

  return {
    status: 404,
    chunks: ['not-found'],
    title,
    description,
    component: (
      <Layout>
        <NotFound title={title} specialCars={specialCars} />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/not-found/index.js